/**
 * The job API sometimes sends the text "None" (a Python None turned into a string) or
 * "null" where a value is simply missing — departmentName on some ads, for one — and the
 * job page showed it as a chip reading "None". Missing is missing: this turns those strings
 * into null on the top level of one object. Anything else, including nested data, is left
 * exactly as it was.
 */
const PLACEHOLDER = /^(none|null|undefined|nan)$/i;

export const isPlaceholderText = (value) =>
  typeof value === "string" && PLACEHOLDER.test(value.trim());

export const cleanApiValues = (obj) => {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return obj;
  let out = null;
  Object.keys(obj).forEach((key) => {
    if (isPlaceholderText(obj[key])) {
      if (!out) out = { ...obj };
      out[key] = null;
    }
  });
  return out || obj;
};

export default cleanApiValues;
